import styled from 'styled-components';
import { TagIcon as TIcon, UserIcon as UIcon } from '@heroicons/react/outline';

export const Container = styled.div`
  margin: 0 auto 0 auto;
  width: 800px;
  /* display: flex; */
  padding: 20px 0;
`;
